// javascript
import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import Popper from '@mui/material/Popper';
import Paper from '@mui/material/Paper';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import MenuList from '@mui/material/MenuList';
import { Link } from "react-router-dom";

const pages = [
    {
        id: 'news',
        name: 'Actualités',
        url: '/actualites'
    },
    {
        id: 'club',
        name: 'Le Club',
        url: '/le-club',
        children: [
            { id: 'history', name: 'Qui sommes nous ?', url: '/le-club/about-us' },
            { id: 'teams', name: 'Les Équipes', url: '/le-club/equipes' },
            { id: 'youth', name: 'La section jeune', url: '/le-club/section-jeune' }

        ]
    },
    {
        id: 'contactme',
        name: 'Nous contacter',
        url: '/nous-contacter'
    }
];

function ResponsiveAppBar() {
    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [anchorElSubmenu, setAnchorElSubmenu] = React.useState(null);
    const [openSubmenuId, setOpenSubmenuId] = React.useState(null);
    const closeTimeoutRef = React.useRef(null);
    const isHoveringParentRef = React.useRef(false);
    const isHoveringMenuRef = React.useRef(false);
    const CLOSE_DELAY = 150; // ms

    React.useEffect(() => {
        return () => {
            if (closeTimeoutRef.current) {
                clearTimeout(closeTimeoutRef.current);
                closeTimeoutRef.current = null;
            }
        };
    }, []);

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const cancelScheduleClose = () => {
        if (closeTimeoutRef.current) {
            clearTimeout(closeTimeoutRef.current);
            closeTimeoutRef.current = null;
        }
    };
    const scheduleCloseSubmenu = (delay = CLOSE_DELAY) => {
        cancelScheduleClose();
        closeTimeoutRef.current = setTimeout(() => {
            if (!isHoveringParentRef.current && !isHoveringMenuRef.current) {
                setAnchorElSubmenu(null);
                setOpenSubmenuId(null);
            }
            closeTimeoutRef.current = null;
        }, delay);
    };

    const handleOpenSubmenu = (event, pageId) => {
        cancelScheduleClose();
        isHoveringParentRef.current = true;
        setAnchorElSubmenu(event.currentTarget);
        setOpenSubmenuId(pageId);
    };
    const handleCloseSubmenuImmediate = () => {
        cancelScheduleClose();
        isHoveringParentRef.current = false;
        isHoveringMenuRef.current = false;
        setAnchorElSubmenu(null);
        setOpenSubmenuId(null);
    };

    return (
        <AppBar position="static" sx={{ backgroundColor: "black" }}>
            <Container maxWidth="xl">
                <Toolbar disableGutters>
                    <Box href="#app-bar-with-responsive-menu" sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }}>
                        <img src="/logo_vvb_transparent2.png" alt="Vitréenne volley-ball" height={75}/>
                    </Box>

                    <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                        <IconButton
                            size="large"
                            aria-label="menu"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleOpenNavMenu}
                            color="inherit"
                        >
                            <MenuIcon />
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorElNav}
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                            keepMounted
                            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                            open={Boolean(anchorElNav)}
                            onClose={handleCloseNavMenu}
                            sx={{ display: { xs: 'block', md: 'none' } }}
                        >
                            {pages.map((page) => (
                                <Box key={page.id}>
                                    <MenuItem component={Link} to={page.url} onClick={handleCloseNavMenu}>
                                        <Typography sx={{ textAlign: 'center' }}>{page.name}</Typography>
                                    </MenuItem>
                                    {page.children && page.children.map(child => (
                                        <MenuItem
                                            key={child.id}
                                            component={Link}
                                            to={child.url}
                                            onClick={handleCloseNavMenu}
                                            sx={{ pl: 4 }}
                                        >
                                            <Typography sx={{ textAlign: 'left' }}>{child.name}</Typography>
                                        </MenuItem>
                                    ))}
                                </Box>
                            ))}
                        </Menu>
                    </Box>

                    <Box sx={{ display: { xs: 'flex', md: 'none' }, mr: 1 }}>
                        <img src="/logo_vvb_transparent2.png" alt="Vitréenne volley-ball" height={50}/>
                    </Box>
                    <Typography
                        variant="h4"
                        noWrap
                        component="a"
                        href="#app-bar-with-responsive-menu"
                        sx={{
                            mr: 2,
                            display: { xs: 'flex', md: 'none' },
                            flexGrow: 1,
                            fontFamily: 'monospace',
                            fontWeight: 700,
                            letterSpacing: '.3rem',
                            color: 'inherit',
                            textDecoration: 'none',
                        }}
                    >
                        Vitréenne volley-ball
                    </Typography>

                    {/* Desktop nav with hover submenus */}
                    <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
                        {pages.map((page) => (
                            <Box
                                key={page.id}
                                onMouseEnter={(e) => {
                                    cancelScheduleClose();
                                    if (page.children) {
                                        handleOpenSubmenu(e, page.id);
                                    } else {
                                        // fermer immédiatement le sous-menu si le parent n'a pas d'enfants
                                        handleCloseSubmenuImmediate();
                                    }
                                }}
                                onMouseLeave={() => {
                                    if (page.children) {
                                        isHoveringParentRef.current = false;
                                        scheduleCloseSubmenu();
                                    }
                                }}
                                sx={{ display: 'inline-block' }}
                            >
                                <Button
                                    component={page.children ? 'button' : Link}
                                    to={page.children ? undefined : page.url}
                                    onClick={() => {
                                        if (!page.children) {
                                            handleCloseSubmenuImmediate();
                                        }
                                    }}
                                    sx={{ my: 2, color: 'white', display: 'block' }}
                                >
                                    <Typography variant="h6">
                                        {page.name}
                                    </Typography>
                                </Button>

                                {page.children && (
                                    <Popper
                                        open={openSubmenuId === page.id}
                                        anchorEl={anchorElSubmenu}
                                        placement="bottom-start"
                                        modifiers={[{ name: 'offset', options: { offset: [0, 8] } }]}
                                        sx={{ zIndex: (t) => t.zIndex.modal + 10 }}
                                    >
                                        <ClickAwayListener onClickAway={handleCloseSubmenuImmediate}>
                                            <Paper
                                                sx={{ backgroundColor: 'white', color: 'black' }}
                                                onMouseEnter={() => {
                                                isHoveringMenuRef.current = true;
                                                cancelScheduleClose();
                                            }}
                                                   onMouseLeave={() => {
                                                       isHoveringMenuRef.current = false;
                                                       scheduleCloseSubmenu();
                                                   }}
                                            >
                                                <MenuList>
                                                    {page.children.map(child => (
                                                        <MenuItem
                                                            key={child.id}
                                                            component={Link}
                                                            to={child.url}
                                                            onClick={() => { handleCloseSubmenuImmediate(); }}
                                                        >
                                                            <Typography sx={{ textAlign: 'center' }}>{child.name}</Typography>
                                                        </MenuItem>
                                                    ))}
                                                </MenuList>
                                            </Paper>
                                        </ClickAwayListener>
                                    </Popper>
                                )}
                            </Box>
                        ))}
                    </Box>
                </Toolbar>
            </Container>
        </AppBar>
    );
}
export default ResponsiveAppBar;
